import { render, staticRenderFns } from "./EmailList.vue?vue&type=template&id=022d8d21&scoped=true"
import script from "./EmailList.ts?vue&type=script&lang=js&external"
export * from "./EmailList.ts?vue&type=script&lang=js&external"
import style0 from "./EmailList.scss?vue&type=style&index=0&id=022d8d21&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022d8d21",
  null
  
)

export default component.exports